// extracted by mini-css-extract-plugin
export default {"dropdown_menu1":"autosuggestioncomponent_dropdown_menu1__67WWv"};